import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { SavedRitualsProvider } from './context/SavedRitualsContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import CartPage from './pages/CartPage';
import AboutPage from './pages/AboutPage';
import RitualQuiz from './pages/RitualQuiz';
import Wishlist from './pages/Wishlist';
import Glossary from './pages/Glossary';
import Recipes from './pages/Recipes';
import RecipeDetail from './pages/RecipeDetail';
import HerbArchive from './pages/HerbArchive';
import SavedRituals from './pages/SavedRituals';
import PrintRitualCard from './pages/PrintRitualCard';
import WeeklyDigest from './pages/WeeklyDigest';
import RitualCalendar from './pages/RitualCalendar';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import ReminderBanner from './components/ReminderBanner';
import StreakCelebration from './components/StreakCelebration';
import CookieBanner from './components/CookieBanner';
import { PaymentSuccess, PaymentCancel } from './pages/PaymentResult';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App min-h-screen bg-[#faf7f1] text-[#2f2a24]">
      <WishlistProvider>
        <SavedRitualsProvider>
          <CartProvider>
            <BrowserRouter>
              <Header />
              <CartDrawer />
              <ReminderBanner />
              <StreakCelebration />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/collections/all" element={<Shop />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/quiz" element={<RitualQuiz />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/glossary" element={<Glossary />} />
                  <Route path="/archive" element={<HerbArchive />} />
                  <Route path="/recipes" element={<Recipes />} />
                  <Route path="/recipes/:id" element={<RecipeDetail />} />
                  <Route path="/rituals" element={<SavedRituals />} />
                  <Route path="/rituals/calendar" element={<RitualCalendar />} />
                  <Route path="/rituals/digest" element={<WeeklyDigest />} />
                  <Route path="/recipes/:id/print" element={<PrintRitualCard />} />
                  <Route path="/policies/refund" element={<RefundPolicy />} />
                  <Route path="/policies/shipping" element={<ShippingPolicy />} />
                  <Route path="/policies/privacy" element={<PrivacyPolicy />} />
                  <Route path="/policies/terms" element={<TermsOfService />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Routes>
              </main>
              <Footer />
              <CookieBanner />
              <Toaster position="top-center" />
            </BrowserRouter>
          </CartProvider>
        </SavedRitualsProvider>
      </WishlistProvider>
    </div>
  );
}

export default App;
